import { Button } from './ui/Button';
export const Switch = ({
  checked,
  onChange
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
}) => {
  return (
    <Button tone="custom"
      type="button"
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-5 w-9 items-center rounded-full transition-colors ${
        checked ? "bg-blue-600" : "bg-gray-300"
      }`}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
          checked ? "translate-x-4" : "translate-x-1"
        }`}
      />
    </Button>
  );
};
